
import Modal from './components/common/Modal.vue'
import Loading from './components/common/Loading.vue'
import { defineComponent, computed, ref, getCurrentInstance } from 'vue'
import { useApi } from './lib/api'
import { useStore } from 'vuex'
import { GlobalState } from './lib/types'
import { errorMap } from '@/lib/filters'
import { useRouter, useRoute } from 'vue-router'
import Accessibility from './components/Accessibility.vue'
import Toaster from './components/common/Toaster.vue'

export default defineComponent({
  components: { Loading, Modal, Accessibility, Toaster },

  setup() {
    const _root = getCurrentInstance()
    const _api = useApi()
    const _store = useStore<GlobalState>()
    const _route = useRoute()
    const _router = useRouter()
    const dlgAppEnvironment = ref()
    const footer = ref()
    const toast = ref()
    const toastTheme = ref({ theme: 'green', text: null })
    const state = ref({
      showNotAuth: false,
      domainName: ''
    })

    const ping = async () => {
      const res = await _api.get<any>('ping')
      if (res.status === 200) {
        _store.commit('appData', res.data.appSettings)
        if (res.data.isAuthenticated) {
          _store.commit('user', res.data.user)

          let url = ''
          if (_route.meta.requestUrl) {
            const reqUrl = _route.meta.requestUrl as string
            url = reqUrl.substring(reqUrl.indexOf('#/') + 2)
          }

          if (url.length > 0) {
            _router.push({ path: '/' + url })
          } else {
            _router.push({ name: 'reportList' })
          }
        } else {
          state.value.showNotAuth = true
        }

        const info = await import('../package.json')

        if (_store.state.appData?.jsVersion !== info.version) {
          dlgAppEnvironment.value.open()
        }
      } else {
        _store.commit('appErrors', [{ key: '.', message: 'Prišlo je do napake.' }])
      }
    }

    const logout = async () => {
      await _router.push({ name: 'index' })
      await _api.post('logout', null)
      _store.commit('user', null)
    }

    const getFooter = async () => {
      const res = await _api.cache.get<any>('footer')
      footer.value = res.data.text
    }

    const appEnvironmentDesc = computed(() => {
      switch (_store.state.appData?.appEnvironment) {
        case 0:
          return 'Razvojno okolje'
        case 1:
          return 'TESTNO OKOLJE'
        default:
          return null
      }
    })

    _root?.appContext.config.globalProperties.emitter.on('showToaster', (t: any) => {
      toastTheme.value = t
      toast.value.show()
    })

    getFooter()
    ping()

    return { stateGlobal: _store.state, state, appEnvironmentDesc, dlgAppEnvironment, logout, errorMap, toast, toastTheme, footer }
  }
})
